(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function updatePopularEssentialsDestination() {
  function updateLinks(root = document) {
    root.querySelectorAll('.hp-paw-header a[href*="/collections/add-ons"]').forEach((link) => {
      link.setAttribute('href', '/collections/popular-essentials');
      link.setAttribute('aria-label', 'Popular Essentials');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateLinks(), { once: true });
  } else {
    updateLinks();
  }

  document.addEventListener('shopify:section:load', (event) => updateLinks(event.target));
})();
